<e-numpad-input label="stuks" style="width: 300px" class="m-4"></e-numpad-input>
